class AnnouncementBar extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.announcement-bar__slide:not(.hidden)'));
    
    // Keep theme height offset variables updated
    this.updateOffsetHeights();
    const resizeObserver = new ResizeObserver(() => this.updateOffsetHeights());
    resizeObserver.observe(this);

    if (this.slides.length <= 1) return;

    this.prevBtn = this.querySelector('.announcement-bar__arrow--prev');
    this.nextBtn = this.querySelector('.announcement-bar__arrow--next');
    this.autoplay = this.dataset.autoplay === 'true';
    
    this.speedDesktop = parseInt(this.dataset.speedDesktop) || 5000;
    this.speedMobile = parseInt(this.dataset.speedMobile) || 5000;
    
    this.currentIndex = 0;
    this.timer = null;

    if (this.prevBtn) {
      this.prevBtn.style.display = 'flex';
      this.prevBtn.addEventListener('click', () => {
        this.stopAutoplay();
        this.prevSlide();
        this.startAutoplay();
      });
    }

    if (this.nextBtn) {
      this.nextBtn.style.display = 'flex';
      this.nextBtn.addEventListener('click', () => {
        this.stopAutoplay();
        this.nextSlide();
        this.startAutoplay();
      });
    }

    this.addEventListener('mouseenter', () => this.stopAutoplay());
    this.addEventListener('mouseleave', () => this.startAutoplay());

    window.addEventListener('resize', () => {
      this.stopAutoplay();
      this.startAutoplay();
    });

    this.showSlide(this.currentIndex);
    this.startAutoplay();
  }

  updateOffsetHeights() {
    const height = this.offsetHeight;
    document.documentElement.style.setProperty('--announcement-bar-height', `${height}px`);
    document.documentElement.style.setProperty('--announcement-bar-height-mobile', `${height}px`);
  }

  getSpeed() {
    return window.innerWidth >= 750 ? this.speedDesktop : this.speedMobile;
  }

  showSlide(index) {
    this.slides.forEach((slide, i) => {
      if (i === index) {
        if (slide.classList.contains('exit-up')) {
          slide.style.transition = 'none';
          slide.classList.remove('exit-up');
          void slide.offsetWidth;
          slide.style.transition = '';
          
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              slide.classList.add('is-active');
            });
          });
        } else {
          slide.classList.add('is-active');
        }
        
        // Update parent background color dynamically
        const bgColor = slide.dataset.backgroundColor;
        if (bgColor) {
          this.style.backgroundColor = bgColor;
        }

        // Dynamic coloring for arrows inheriting from active slide text color
        const slideColor = getComputedStyle(slide).color;
        if (this.prevBtn) this.prevBtn.style.color = slideColor;
        if (this.nextBtn) this.nextBtn.style.color = slideColor;
      } else if (slide.classList.contains('is-active')) {
        slide.classList.remove('is-active');
        slide.classList.add('exit-up');
      } else {
        if (slide.classList.contains('exit-up')) {
          slide.style.transition = 'none';
          slide.classList.remove('exit-up');
          void slide.offsetWidth;
          slide.style.transition = '';
        }
      }
    });
    this.currentIndex = index;
  }

  nextSlide() {
    let nextIndex = this.currentIndex + 1;
    if (nextIndex >= this.slides.length) {
      nextIndex = 0;
    }
    this.showSlide(nextIndex);
  }

  prevSlide() {
    let prevIndex = this.currentIndex - 1;
    if (prevIndex < 0) {
      prevIndex = this.slides.length - 1;
    }
    this.showSlide(prevIndex);
  }

  startAutoplay() {
    if (!this.autoplay) return;
    const speed = this.getSpeed();
    if (speed <= 0) return;
    this.stopAutoplay();
    this.timer = setInterval(() => {
      this.nextSlide();
    }, speed);
  }

  stopAutoplay() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  disconnectedCallback() {
    this.stopAutoplay();
  }
}

if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar);
}

class AnnouncementCountdown extends HTMLElement {
  connectedCallback() {
    const targetDate = this.getAttribute('data-date');
    const targetTime = this.getAttribute('data-time') || '00:00';
    const expiredMsg = this.getAttribute('data-expired-message') || '';

    if (!targetDate) return;

    const targetStr = `${targetDate}T${targetTime}:00`;
    const targetTimeMs = new Date(targetStr).getTime();

    if (isNaN(targetTimeMs)) {
      console.error('Invalid countdown date/time:', targetStr);
      return;
    }

    this.updateTimer(targetTimeMs, expiredMsg);
    this.timer = setInterval(() => {
      this.updateTimer(targetTimeMs, expiredMsg);
    }, 1000);
  }

  updateTimer(targetTimeMs, expiredMsg) {
    const now = new Date().getTime();
    const distance = targetTimeMs - now;

    if (distance < 0) {
      this.innerHTML = expiredMsg;
      clearInterval(this.timer);
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    let html = '';
    if (days > 0) {
      html += `${days}d : `;
    }
    html += `${hours.toString().padStart(2, '0')}h : `;
    html += `${minutes.toString().padStart(2, '0')}m : `;
    html += `${seconds.toString().padStart(2, '0')}s`;

    this.innerHTML = html;
  }

  disconnectedCallback() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
}

if (!customElements.get('announcement-countdown')) {
  customElements.define('announcement-countdown', AnnouncementCountdown);
}
